import {
    takeEvery,
    put
} from 'redux-saga/effects';

import SecurityService from 'services/SecurityService';
import api from 'services/restApiHelper';
const baseUrl = process.env.REACT_APP_BASE_URL;

export function* fetchUsersFlow(action) {
    try {
        const response = yield api.get(`${baseUrl}/users`);
        yield put({
            type: SecurityService.USERS_FETCH_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: SecurityService.USERS_FETCH_ERROR,
            error
        });
    }
}

export function* fetchPermissionsFlow(action) {
    try {
        const response = yield api.get(`${baseUrl}/permissions/processes`);
        yield put({
            type: SecurityService.PERMISSIONS_FETCH_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: SecurityService.PERMISSIONS_FETCH_ERROR,
            error
        });
    }
}

export function* loginFlow(action) {
    try {
        const hash = btoa(`${action.username}:${action.password}`);
        const options = {
            headers: { Accept: 'application/json',  Authorization: `Basic ${hash}` }
        };

        const response = yield api.post(`${baseUrl}/login`, null, options);
        yield put({
            type: SecurityService.LOGIN_SUCCESS,
            response
        });
        yield put({ type: SecurityService.PERMISSIONS_FETCH_START }); // after login, make sure to re-load permissions

    } catch (error) {
        yield put({
            type: SecurityService.LOGIN_ERROR,
            error
        });
    }
}

/**
 * This is essentially the exact same code as the poll flow, except we also trigger the permissions fetch if
 * the sessionID is still valid.  TODO: can we use subroutines with generator functions so we don't have
 * duplicate code?
 */
export function* loginSSOFlow() {
    try {
        const sessionId = localStorage.getItem('sessionId');
        const response = yield api.get(`${baseUrl}/keepAlive?sessionId=${sessionId}`);

        if (response.sessionIdsMatch === false) {
            yield put({
                type: SecurityService.LOGOUT_START
            });
        } else {
            yield put({
                type: SecurityService.LOGIN_SSO_SUCCESS,
                response
            });
            yield put({ type: SecurityService.PERMISSIONS_FETCH_START }); // after login, make sure to re-load permissions
        }

        const buildVersion = sessionStorage.getItem('buildVersion');
        if (buildVersion) {
            //if client buildVersion doesn't match one from server first update
            //the sessionStorage (so we don't keep popping up alerts with each call to keepAlive)
            //then open modal dialog to let user know they need to refresh
            if (buildVersion !== response.buildVersion) {
                sessionStorage.setItem('buildVersion', response.buildVersion);
                yield put({
                    type: SecurityService.BUILD_VERSION_UPDATED
                });
            }
        } else {
            // else this is the first call to keepAlive we need to just store the buildVersion:
            sessionStorage.setItem('buildVersion', response.buildVersion);
        }

    } catch (error) {
        yield put({
            type: SecurityService.LOGIN_SSO_ERROR
        });
    }

}

export function* logoutFlow() {
    try {
        const response = yield api.post(`${baseUrl}/logout`);
        yield put({
            type: SecurityService.LOGOUT_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: SecurityService.LOGOUT_ERROR,
            error
        });
    }
}

export function* pollFlow() {
    try {
        const sessionId = localStorage.getItem('sessionId');
        let params = '';
        if (sessionId) {
            params = `?sessionId=${sessionId}`;
        }
        const response = yield api.get(`${baseUrl}/keepAlive${params}`);

        if (response.sessionIdsMatch === false) {
            yield put({
                type: SecurityService.LOGOUT_START
            });
        }

        const buildVersion = sessionStorage.getItem('buildVersion');
        if (buildVersion) {
            //if client buildVersion doesn't match one from server first update
            //the sessionStorage (so we don't keep popping up alerts with each call to keepAlive)
            //then open modal dialog to let user know they need to refresh
            if (buildVersion !== response.buildVersion) {
                sessionStorage.setItem('buildVersion', response.buildVersion);
                yield put({
                    type: SecurityService.BUILD_VERSION_UPDATED
                });
            }
        } else {
            //else this is the first call to keepAlive we need to just store the buildVersion:
            sessionStorage.setItem('buildVersion', response.buildVersion);
        }

        yield put({
            type: SecurityService.POLL_SUCCESS,
            response
        });
    } catch (error) {
        yield put({
            type: SecurityService.POLL_ERROR
        });
    }
}

export function* watchSecurityServiceRequests() {
    yield takeEvery(SecurityService.LOGIN_START, loginFlow);
    yield takeEvery(SecurityService.POLL_START, pollFlow);
    yield takeEvery(SecurityService.LOGIN_SSO_START, loginSSOFlow);
    yield takeEvery(SecurityService.LOGOUT_START, logoutFlow);
    yield takeEvery(SecurityService.PERMISSIONS_FETCH_START, fetchPermissionsFlow);
    yield takeEvery(SecurityService.USERS_FETCH_START, fetchUsersFlow);
}



// WEBPACK FOOTER //
// ./src/services/sagas/SecurityServiceSagas.js